// BullMQ queue names cannot contain ":" — use "." as the namespace separator instead.
export const QUEUE_NAMES = {
    UPLOAD: "sentinel.upload",
    METADATA: "sentinel.metadata",
    FRAME: "sentinel.frame",
    OCR: "sentinel.ocr",
    REGEX: "sentinel.regex",
    QR: "sentinel.qr",
    SPEECH: "sentinel.speech",
    FACE: "sentinel.face",
    NUMBER_PLATE: "sentinel.number_plate",
    LOGO: "sentinel.logo",
    DOCUMENT: "sentinel.document",
    PATCH: "sentinel.patch",
    AUDIO_PATCH: "sentinel.audio_patch",
    ENCODING: "sentinel.encoding",
    RISK: "sentinel.risk",
    PUBLISHING: "sentinel.publishing",
} as const;